import styled from 'styled-components';

export const NotifBtnContainer = styled.div`
  position: relative;
  margin-right: 38px;
  max-height: 17px;
`